module.exports = __webpack_public_path__ + "static/media/discord-black.25354ad2.svg";